<template>
  <div class="d-flex align-items-center">
    <Tooltip
      v-if="data.field.helpTxt"
      :help-text="data.field.helpTxt"
      :help-id="data.field.label"
      :label="data.field.label"
    />
    <button
      class="sort-button d-flex text-left"
      :class="{ sorted: isSorted }"
      @click="handleClick"
      :aria-label="ariaLabel"
      :aria-sort="ariaSort"
      :title="sortTitle"
    >
      <span>{{ data.field.label }}</span>

      <!-- Sortable Icon -->
      <b-icon
        :icon="sortIcon"
        class="ml-1 sort-icon"
        style="padding-top: 3px"
      ></b-icon>
    </button>
  </div>
</template>

<script>
import {
  BIcon,
  BIconArrowDownUp,
  BIconArrowUp,
  BIconArrowDown,
} from "bootstrap-vue";
import Tooltip from "@/components/common/Tooltip.vue";

export default {
  components: {
    BIcon,
    BIconArrowDownUp,
    BIconArrowUp,
    BIconArrowDown,
    Tooltip,
  },
  props: ["data", "sortKey", "sortOrder"],
  computed: {
    isSorted() {
      return this.sortKey === this.data.field.key;
    },
    sortIcon() {
      if (!this.isSorted) {
        return "arrow-down-up";
      }
      return this.sortOrder === 1 ? "arrow-up" : "arrow-down";
    },
    ariaSort() {
      if (!this.isSorted) {
        return null;
      }
      return this.sortOrder === 1 ? "ascending" : "descending";
    },
    ariaLabel() {
      return `Sort by ${this.data.field.label}`;
    },
    sortTitle() {
      if (this.isSorted) {
        return this.sortOrder === 1 ? "Sort descending" : "Sort ascending";
      }
      return `Sort by ${this.data.field.label}`;
    },
  },
  methods: {
    handleClick() {
      this.$emit("header-clicked", this.data.field.key);
    },
  },
};
</script>

<style scoped>
.sort-button {
  background: transparent;
  border: none;
  padding: 0;
  margin: 0;
  font: inherit;
  color: inherit;
  width: 100%;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.sort-button:hover,
.sort-button:focus {
  background-color: #f5f5f5;
  outline: none;
}
.sorted {
  font-weight: bold;
}

.sort-icon {
  transition: opacity 0.2s ease;
  opacity: 0.5;
}

.sort-button:hover .sort-icon,
.sort-button:focus .sort-icon,
.sorted .sort-icon {
  opacity: 1;
}
</style>
